<template>
  <div 
    v-if="show" 
    class="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center z-index-1000 rounded-lg"
  >
    <div class="text-center p-4 bg-white bg-opacity-90 rounded shadow-md">
      <span class="material-icons text-amber-500 text-4xl mb-2">{{ icon }}</span>
      <p class="text-gray-800 font-medium" v-html="message"></p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ErrorOverlay',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'error_outline'
    },
    message: {
      type: String,
      default: '情報の取得中にエラーが発生しました<br>後でもう一度お試しください'
    }
  }
});
</script>

<style scoped>
.z-index-1000 {
  z-index: 1000;
}
</style> 